import React from 'react';
import dayjs from 'dayjs';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import {  ErrorMessage, useField } from 'formik';

export const DatePicker = ({label, ...props}) => {
    const [field, meta] = useField(props);
    //console.log(field,meta); 
    
  const [value, setValue] = React.useState(dayjs());
   
  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: 500,
        paddingTop: '10px',
        paddingBottom: '20px',
        maxWidth: '100%',
      }}
    >
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack spacing={3}>
        
        <MobileDatePicker
      
          label={label}
          inputFormat="YYYY-MM-DD"
          value={value}
          onChange={handleChange}
          renderInput={(props) =><TextField {...props} /> }
        />
        
      </Stack>
    </LocalizationProvider>
    <ErrorMessage component="div" name={field.name} className="error" />
    </Box>
  );
}
